const  declineReducer = (state = {}, action) => {
    switch (action.type) {
      case "DELETE_APPLICATION": {
        return{
          ...state,
          declineApplicationSuccess: action.success
        }
      }
      case "DELETE_APPLICATION_ERR": {
        return{
          ...state,
          declineApplicationError: action.err
        }
      }
      default:
        return state;
    }
  };
  
  export default declineReducer;
  